// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ma-3";
export var downloadButton = "_ma-4";
export var fileContainer = "_ma-9 _ma-7";
export var fileContainerBase = "_ma-7";
export var fileContainerFixedHeight = "_ma-8 _ma-7";
export var fileInfo = "_ma-5";
export var fileInfoWidthRestricted = "_ma-6";
export var fileType = "_ma-1";
export var fileTypeName = "_ma-2";
export var image = "_ma-0";
export var link = "_ma-b";
export var overflowEllipsis = "_ma-a";